/**
 * @GENERATED from Figma node 693:15908
 */

import { useUniqueInlineId } from "@inline-svg-unique-id/react";
import * as React from "react";
export type IconProps = Omit<React.SVGProps<SVGSVGElement>, "color">;
const ClickUpBright = function (
  props: IconProps,
  ref: React.Ref<SVGSVGElement>,
) {
  const _id2 = useUniqueInlineId();
  const _id = useUniqueInlineId();
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      focusable={false}
      role="presentation"
      ref={ref}
      {...props}
    >
      <path
        fill={`url(#${_id})`}
        d="m4 17.366 3.075-2.357c1.634 2.133 3.37 3.116 5.303 3.116 1.922 0 3.609-.971 5.169-3.087l3.12 2.3c-2.252 3.05-5.05 4.662-8.29 4.662C9.15 22 6.325 20.398 4 17.366"
      />
      <path
        fill={`url(#${_id2})`}
        d="m12.368 7.125-5.474 4.717-2.53-2.934L12.378 2l7.953 6.913-2.542 2.924z"
      />
      <defs>
        <linearGradient
          id={_id}
          x1={4}
          x2={20.666}
          y1={19.764}
          y2={19.764}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#8930FD" />
          <stop offset={1} stopColor="#49CCF9" />
        </linearGradient>
        <linearGradient
          id={_id2}
          x1={4.363}
          x2={20.332}
          y1={8.694}
          y2={8.694}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF02F0" />
          <stop offset={1} stopColor="#FFC800" />
        </linearGradient>
      </defs>
    </svg>
  );
};
const ForwardRef = React.forwardRef(ClickUpBright);
export { ForwardRef as ClickUpBright };
